import { NgModule } from '@angular/core';
import { CreditCredentialsConfigurationComponent } from './credit-credentials-configuration.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CreditCredentialsConfigurationDialogComponent } from './credit-credentials-configuration-dialog/credit-credentials-configuration-dialog.component';
import { CreditCredentialsConfigProviderFactory } from './config/credit-credentials-config-provider.factory';
import { DefaultCreditCredentialsConfigProvider } from './config/default-credit-credentials-config.provider';
import { DeephavenCreditCredentialsConfigProvider } from './config/deephaven-credit-credentials-config-provider';
import { CreditConfigService } from '../global-admin/credit-config/services/credit-config.service';

@NgModule({
  declarations: [
    CreditCredentialsConfigurationComponent,
    CreditCredentialsConfigurationDialogComponent,
  ],
  imports: [SharedModule],
  exports: [
    CreditCredentialsConfigurationComponent,
    CreditCredentialsConfigurationDialogComponent,
  ],
  providers: [CreditCredentialsConfigProviderFactory, DefaultCreditCredentialsConfigProvider, DeephavenCreditCredentialsConfigProvider, CreditConfigService],
})
export class CreditCredentialsConfigurationModule {
  constructor() {}
}
